export default "__VITE_ASSET__DiarpBkl__"